var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIReferenceAi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2012_25726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25782 6.81465L8.54596 6.99967C7.01122 7.39965 5.81127 8.59784 5.41129 10.1343L5.22627 10.8462C5.18398 11.0118 4.94787 11.0118 4.90382 10.8462L4.71881 10.1343C4.31882 8.5996 3.12063 7.39965 1.58414 6.99967L0.872271 6.81465C0.706639 6.77236 0.706639 6.53625 0.872271 6.4922L1.58414 6.30718C3.11887 5.9072 4.31882 4.70901 4.71881 3.17251L4.90382 2.46065C4.94611 2.29502 5.18222 2.29502 5.22627 2.46065L5.41129 3.17251C5.81127 4.70725 7.00946 5.9072 8.54596 6.30718L9.25782 6.4922C9.42345 6.53449 9.42345 6.7706 9.25782 6.81465Z",
    fill: "#C4C8CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1959 3.06329L10.8875 3.14258C10.2232 3.31526 9.70345 3.83507 9.53077 4.49936L9.45148 4.80771C9.43209 4.87996 9.33166 4.87996 9.31227 4.80771L9.23298 4.49936C9.0603 3.83507 8.5405 3.31526 7.87621 3.14258L7.56785 3.06329C7.49561 3.04391 7.49561 2.94347 7.56785 2.92409L7.87621 2.8448C8.5405 2.67212 9.0603 2.15232 9.23298 1.48803L9.31227 1.17967C9.33166 1.10743 9.43209 1.10743 9.45148 1.17967L9.53077 1.48803C9.70345 2.15232 10.2232 2.67212 10.8875 2.8448L11.1959 2.92409C11.2681 2.94347 11.2681 3.04391 11.1959 3.06329Z",
    fill: "#C4C8CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2012_25726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 9.84452,
    fill: "white",
    transform: "translate(0.75 1.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIReferenceAi);
export default __webpack_public_path__ + "static/media/i_reference_ai.7386d450b77e4291355098e8d3ee08b5.svg";
export { ForwardRef as ReactComponent };